module.exports = __webpack_public_path__ + "img/Django.9c527b8.svg";